import { ValueNode } from './ValueNode';
export class RawNode extends ValueNode {
    value;
    constructor(id, value, key, metadata) {
        super(id, key, metadata);
        this.value = value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmF3Tm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL1Jhd05vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUl2QyxNQUFNLE9BQU8sT0FBUSxTQUFRLFNBQVM7SUFDM0IsS0FBSyxDQUFVO0lBRXhCLFlBQVksRUFBVSxFQUFFLEtBQWUsRUFBRSxHQUFZLEVBQUUsUUFBbUI7UUFDeEUsS0FBSyxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUE7UUFDeEIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDcEIsQ0FBQztDQUNGIn0=